<div>
  <table style="width: 100%">
    <tr>
      <td>
  <app-header></app-header>
        </td>
      <td style="width: 50px">
        
          <app-doc-basket-ex (loaderEvent)="receiveLoader($event)"></app-doc-basket-ex>
        
      </td>
      </tr>
    </table>
</div>
<div class="side" *ngIf="nav.visible" [ngStyle]="{'left': screenWidth > 521 ? '0px': (!nav.toggleMenu) ? '-200px' : '0px'}">
  <app-nav-menu></app-nav-menu>
</div>
<!--<div class="main" style="opacity:1.0;filter:alpha(opacity=100);" [ngStyle]="{'width':nav.visible ? screenWidth > 520 && screenWidth <=768 ? 'calc(100% - 200px)' : 'calc(100% - 242px)' : '100%', 'background-image':nav.visible ? 'url(\'images/nh-bg.jpg\')' : 'none' }" >-->
<div class="main" style="opacity:1.0;filter:alpha(opacity=100);" [ngStyle]="{'width':nav.visible ? screenWidth > 520 && screenWidth <=768 ? 'calc(100% - 200px)' : 'calc(100% - 242px)' : '100%', 'background-image':false ? 'url(\'images/rod-bg.jpg\')' : 'none' }" >
  <router-outlet></router-outlet>
</div>
